/*
* Recursively flattens an array of nested arrays
* @param {Array} a
* @param {Array} r
* @return {Array} r
*/
export function flattenArrayRecursive (a, r) {
  if (!r) r = []
  for (let i = 0; i < a.length; i++) {
    if (a[i].constructor === Array) {
      r.concat(flattenArrayRecursive(a[i], r))
    } else {
      r.push(a[i])
    }
  }
  return r
}



// WEBPACK FOOTER //
// ./src/utils/helpers/FlattenArray.js